<template>
  <v-main app>
    <router-view />
    <core-footer />
  </v-main>
</template>

<script>
  export default {
    name: 'CoreView',

    components: {
      CoreFooter: () => import('./Footer'),
    },
  }
</script>